import { render } from "./AdminApisPage.vue?vue&type=template&id=323b3cc6"
import script from "./AdminApisPage.vue?vue&type=script&lang=js"
export * from "./AdminApisPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__